import { computed, inject, Type } from '@angular/core';

import { signalStore, withComputed, withProps, withState } from '@ngrx/signals';
import { Events, on, withReducer } from '@ngrx/signals/events';

import { SOCKET_HANDLER_EVENTS } from '../events';
import { SOCKET_HANDLER_INJECTION_CONTEXT } from '../../constants';
import { SocketHandlerSignalStore } from '@data-access/shared';

export const SOCKET_HANDLER_SIGNAL_STORE = signalStore(
  { providedIn: 'root' },
  withState(() => inject(SOCKET_HANDLER_INJECTION_CONTEXT)),
  withProps((_store) => ({
    _events: inject(Events),
  })),
  withComputed(({ ...store }) => ({
    $dashboardSocketEvent: computed(() => store.dashboardEvent()),
  })),
  withReducer(
    on(SOCKET_HANDLER_EVENTS.dispatchDashboardEvent, ({ payload }) => ({
      dashboardEvent: { ...payload },
    })),
    on(SOCKET_HANDLER_EVENTS.resetDashboardEvent, () => ({
      dashboardEvent: null,
    })),
  ),
) satisfies Type<SocketHandlerSignalStore>;
